import { useState, useEffect } from 'react';
import { Button, Typography } from 'antd';

const { Text } = Typography;

const CONSENT_KEY = 'mordeczka_cookie_consent';

/**
 * Pasek zgody na ciasteczka zgodny z RODO/GDPR.
 * Delikatny pasek na dole strony, nie blokuje dostępu do strony.
 * Analityka jest uruchamiana dopiero po świadomej zgodzie użytkownika.
 */
export function CookieConsent() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Sprawdź zapisaną zgodę
        const savedConsent = localStorage.getItem(CONSENT_KEY);

        if (savedConsent === 'accepted') {
            window.gtag?.('consent', 'update', { analytics_storage: 'granted' });
        } else if (!savedConsent) {
            // Brak zapisanej zgody - pokaż pasek
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(CONSENT_KEY, 'accepted');
        window.gtag?.('consent', 'update', { analytics_storage: 'granted' });
        window.dispatchEvent(new Event('mordeczka:analytics-consent'));
        setIsVisible(false);
    };

    const handleReject = () => {
        localStorage.setItem(CONSENT_KEY, 'rejected');
        window.gtag?.('consent', 'update', { analytics_storage: 'denied' });
        setIsVisible(false);
    };

    // Nie renderuj jeśli użytkownik już zaakceptował lub banner jest ukryty
    if (!isVisible) {
        return null;
    }

    return (
        <div className="cookie-consent-banner">
            <div className="cookie-consent-banner-content">
                <Text className="cookie-consent-banner-text">
                    🍪 Ta strona używa plików cookies do analizy ruchu i poprawy jakości usług.
                </Text>
                <Button
                    size="small"
                    onClick={handleReject}
                >
                    Tylko niezbędne
                </Button>
                <Button
                    type="primary"
                    size="small"
                    onClick={handleAccept}
                    className="cookie-consent-banner-button"
                >
                    Akceptuję
                </Button>
            </div>
        </div>
    );
}

// Rozszerzenie typu Window dla gtag
declare global {
    interface Window {
        gtag?: (...args: unknown[]) => void;
        dataLayer?: unknown[];
    }
}
